<template>
  <div>
    <toggleswitch
      :labels="true"
      name="use_vehicle_from_fleet"
      label="Use Vehicle From Fleet?"
      v-model="vehicleForm.use_vehicle_from_fleet"
      helper="Do you want to use a vehicle from your fleet?"
    ></toggleswitch>

    <selectlist
      v-if="vehicleForm.use_vehicle_from_fleet"
      :options="hireSites"
      v-model="vehicleForm.hire_site_id"
      label="Hire Site"
      label-name="name"
      key-name="id"
      placeholder="Please Select"
      helper="Select the hire site"
      :show-error="vehicleForm.errors.has('hire_site_id')"
      name="hire_site_id"
    ></selectlist>

    <div v-if="vehicleForm.use_vehicle_from_fleet">
      <div v-if="!fleet_vehicle">
        <selectlist
          :options="groups"
          v-model="vehicleForm.group_id"
          label="Vehicle Group"
          label-name="name"
          placeholder="Please Select"
          helper="Select the vehicle group"
          :show-error="vehicleForm.errors.has('group')"
          name="group"
        ></selectlist>

        <vehicle-extras
          :value="selectedExtras"
          :extras="extras"
          :useAsFilter="true"
        ></vehicle-extras>

        <button
          type="button"
          class="btn btn-primary btn-block"
          @click="search"
          :disabled="isSearchButtonDisabled"
          :title="searchButtonTitle"
        >
          Search
        </button>

        <table class="table margin-t-10" v-if="!searching && fleetVehicles">
          <thead>
            <tr>
              <th>Registration</th>
              <th>Make &amp; Model</th>
              <th>Group</th>
              <th>Extras</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-bind:key="index" v-for="(vehicle, index) in fleetVehicles">
              <td>
                {{ vehicle.registration }}
              </td>
              <td>{{ vehicle.make?.label }} {{ vehicle.model }}</td>
              <td>
                {{ vehicle.group?.name }}
              </td>
              <td>{{ vehicle | extras }}</td>
              <!--              <td>-->
              <!--                {{ vehicle.transmission?.label }}-->
              <!--              </td>-->
              <!--              <td>-->
              <!--                {{ vehicle.colour }}-->
              <!--              </td>-->
              <td>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="selectVehicle(vehicle)"
                >
                  Select
                </button>
              </td>
            </tr>

            <tr v-if="!fleetVehicles.length">
              <td class="text-center" colspan="7">
                No vehicles found
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="form-group" v-if="fleet_vehicle">
        <div class="col-lg-4 has-helper">
          <label class="control-label">
            Vehicle:
          </label>
        </div>

        <div class="col-lg-8">
          <div class="card mb-3">
            <div class="card-body">
              <div class="float-left" style="margin-top: 8px;">
                {{ fleet_vehicle.registration }} -
                <span v-if="fleet_vehicle.group"
                  >{{ fleet_vehicle.group.name }} -</span
                >
                {{ fleet_vehicle.make.label }} {{ fleet_vehicle.model }}
              </div>
              <div class="float-right">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="clearVehicle"
                  :disabled="!canChangeVehicle"
                  :title="
                    canChangeVehicle
                      ? ''
                      : 'You cannot change the vehicle once the hire has started'
                  "
                >
                  Change Vehicle
                </button>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-lg-6">
          <vehicle-lookup
            v-on:vrm="setRegistration"
            v-on:vehicle="setVehicle"
            :stacked="false"
            label="VRN"
            :show-error="vehicleForm.errors.has('registration')"
            helper="Please enter the vehicle registration number and click the 'Find Vehicle' button"
            :registration="vehicleForm.registration"
          ></vehicle-lookup>

          <selectlist
            :options="makes"
            v-model="vehicleForm.make_id"
            label="Vehicle Make"
            placeholder="Please Select"
            helper="Please select the make for this vehicle"
            :show-error="vehicleForm.errors.has('make')"
            name="make"
          ></selectlist>

          <inputbox
            v-model="vehicleForm.model"
            name="model"
            label="Vehicle Model"
            helper="Please enter the model for this vehicle"
            :show-error="vehicleForm.errors.has('model')"
          ></inputbox>

          <inputbox
            v-model="vehicleForm.mileage_out"
            name="mileage_out"
            label="Current Mileage"
            helper="Please enter the current mileage for the vehicle"
            :show-error="vehicleForm.errors.has('mileage_out')"
          ></inputbox>
        </div>

        <div class="col-lg-6">
          <selectlist
            :options="groups"
            v-model="vehicleForm.group_id"
            label="Vehicle Group"
            label-name="name"
            placeholder="Please Select"
            helper="Please select the group for this vehicle"
            :show-error="vehicleForm.errors.has('group')"
            name="group"
          ></selectlist>

          <inputbox
            v-model="vehicleForm.colour"
            name="vehicle_colour"
            label="Vehicle Colour"
            helper="Please enter the colour of this vehicle"
          ></inputbox>

          <selectlist
            :options="transmissions"
            v-model="vehicleForm.transmission_type_id"
            name="transmission"
            placeholder="Please Select"
            helper="Please select the transmission type for this vehicle"
            label="Vehicle Transmission"
          ></selectlist>
        </div>
      </div>
    </div>

    <fieldset>
      <legend>
        Damage Details
        <small
          >- Please click on the sections of the vehicle to indicate
          damage</small
        >
      </legend>

      <motorbike-damage
        :motorbike="vehicleForm.start_damage"
        :damageToggles="false"
      ></motorbike-damage>

      <input-block
        v-model="vehicleForm.start_damage.description"
        name="description"
        label="Damage Description"
        helper="Add any additional information details about the vehicle damage here"
      ></input-block>
    </fieldset>
  </div>
</template>
<script>
import VehicleLookup from '@/components/Generic/VehicleLookup';
import SplatDiagram from '@/components/Generic/SplatDiagram';
import MotorbikeDamage from '@/components/Modules/Shared/VehicleDamage/MotorbikeDamage';
import VehicleExtras from '@/components/Modules/Fleet/Form/VehicleExtras';

export default {
  props: {
    hire: {
      type: Object,
      required: true
    },
    vehicleForm: {
      type: Object,
      required: true
    },
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    VehicleLookup,
    MotorbikeDamage,
    VehicleExtras
  },

  data() {
    return {
      searching: false,
      fleet_vehicle: null,
      fleetVehicles: [],
      selectedExtras: []
    };
  },

  computed: {
    tenantIdentifier() {
      return this.$store.getters['user']?.tenant?.identifier;
    },

    groups() {
      return this.$store.getters['VehicleGroups/all'].filter(group => {
        return group.name.startsWith('B');
      });
    },

    makes() {
      return this.$store.getters['VehicleMakes/all'];
    },

    transmissions() {
      return this.$store.getters['VehicleTransmissions/all'];
    },

    useVehicleFromFleet() {
      return this.vehicleForm.use_vehicle_from_fleet;
    },

    hireSites() {
      return this.$store.getters['HireSites/all'];
    },

    idleStatus() {
      return this.$store.getters['VehicleStatuses/all'].find(
        status => status.name === 'idle'
      );
    },

    extras() {
      return this.$store.getters['VehicleExtras/all'];
    },

    isSearchButtonDisabled() {
      return (
        !(
          this.vehicleForm.start_date || this.vehicleForm.requested_start_date
        ) || this.searching
      );
    },

    searchButtonTitle() {
      if (
        !this.vehicleForm.start_date &&
        !this.vehicleForm.requested_start_date
      ) {
        return 'You must set at least one of the start/requested start date before you can search';
      }
      return '';
    },

    canChangeVehicle() {
      // If the user has this permission then they can always change the vehicle
      if (this.hasPermission('hires.changeVehiclePostDeployment')) {
        return true;
      }

      // If the vehicle has already stared then prevent changing the vehicle
      if (this.vehicleForm.start_date) {
        return window.DateManager.isAfter(
          this.vehicleForm.start_date,
          new Date()
        );
      }

      return true;
    }
  },

  mounted() {
    this.$store.commit('HireSites/retrieve');
    this.$store.commit('VehicleStatuses/retrieve');
    this.$store.commit('VehicleExtras/retrieve');

    if (this.vehicleForm.use_vehicle_from_fleet) {
      this.fleet_vehicle = this.hire.vehicle?.vehicle || null;
    }
  },

  filters: {
    extras(vehicle) {
      return vehicle.extras?.map(extra => extra.label).join(', ');
    }
  },

  methods: {
    setRegistration(registration) {
      this.vehicleForm.registration = registration;
    },

    selectVehicle(vehicle) {
      this.fleet_vehicle = vehicle;
      this.vehicleForm.fleet_vehicle_identifier = vehicle.identifier;

      this.$emit('vehicleSelected', vehicle);
    },

    clearVehicle() {
      if (this.canChangeVehicle) {
        this.fleet_vehicle = null;
        this.vehicleForm.fleet_vehicle_identifier = null;
        this.$emit('vehicleSelected', null);
      }
    },

    setVehicle(vehicle) {
      this.vehicleForm.transmission_type_id = vehicle.transmission_type_id;
      this.vehicleForm.group_id = vehicle.group_id;
      this.vehicleForm.make_id = vehicle.make_id;
      this.vehicleForm.model = vehicle.model;
      this.vehicleForm.colour = vehicle.colour;
    },

    search() {
      this.searching = true;

      const selectedExtrasStr = this.selectedExtras.join(',');

      window.Ajax.get(
        `/fleet/${this.tenantIdentifier}?filter[group_id]=${this.vehicleForm.group_id}&filter[status_id]=${this.idleStatus?.id}&filter[extras]=${selectedExtrasStr}`
      )
        .then(response => {
          this.searching = false;

          this.fleetVehicles = response.data;
        })
        .catch(err => {
          this.searching = false;
          window.toastify.error(
            'Error',
            'Sorry, an error occurred while searching for vehicles. Please try again'
          );
        });
    },

    updateVehicleDamage(data) {
      this.vehicleForm.start_damage = data;
    }
  }
};
</script>
